import styled from 'styled-components';
import { CustomDialog } from '../../../../../../../components/dialog/v1/CustomDialog';
import CustomBlockButton from '../../../../../../../components/button/CustomBlockButton';
import { useSelectedReturnExchangesActionsContextHook, useSelectedReturnExchangesValueContextHook } from '../../../../contexts/SelectedReturnExchangesContext';
import _ from 'lodash';
import { useApiInfoContextValueHook } from '../../../../../../../contexts/ApiInfoContext';
import { SellertoolSignatureUtils } from '../../../../../../../utils/sellertool-signature-utils';
import { v4 as uuidv4 } from 'uuid';
import { customToast } from '../../../../../../../components/toast/custom-react-toastify/v1';
import { ReturnExchangesApi } from '../../../../../../../apis/ReturnExchangesApi';
import { useFetcher } from '../../../../fetcher/useFetcher';
import { CustomBackdropController } from '../../../../../../../components/backdrop/default/v1';

const StyledHeader = styled.div`
    padding: 10px;
`;

const StyledBody = styled.div`
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    .description{
        font-size: 14px;
    }

    input{
        border-color: #e0e0e0;
        border-radius: 3px;
    }
`;

const StyledFooter = styled.div`
    padding: 10px;

    button{
        background: #333;
        color: #fff;
        border:none;
        font-weight: 600;
        border-radius: 3px;
    }
`;

export function ModalCopyCreate({
    open,
    onClose
}) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();
    const fetcher = useFetcher();
    const selectedReturnExchangesValueContextHook = useSelectedReturnExchangesValueContextHook();
    const selectedReturnExchangesActionsContextHook = useSelectedReturnExchangesActionsContextHook();
    const randomString = generateRandomString();

    const handleCopyCreate = async () => {
        if (!selectedReturnExchangesValueContextHook?.selectedReturnExchanges || selectedReturnExchangesValueContextHook?.selectedReturnExchanges.length === 0) {
            customToast.error('선택된 교환 반품건이 없습니다.');
            return;
        }

        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        const body = {
            formDatas: selectedReturnExchangesValueContextHook?.selectedReturnExchanges.map(item => item?._id),
            copyPostfix: `COPY${randomString}`
        }

        CustomBackdropController().showBackdrop();
        const response = await ReturnExchangesApi().copyCreateList({ headers, body });

        if(response?.content){
            fetcher.fetchReturnExchanges();
            onClose();
        }

        CustomBackdropController().hideBackdrop();
    }

    return (
        <>
            <CustomDialog open={open} onClose={onClose}>
                <StyledHeader>
                    <CustomDialog.Header>
                        <CustomDialog.Header.Fake />
                        <CustomDialog.Header.Title>
                            복사 생성
                        </CustomDialog.Header.Title>
                        <CustomDialog.Header.Close onClick={onClose} />
                    </CustomDialog.Header>
                </StyledHeader>
                <StyledBody>
                    <div className="description">
                        선택건을 복사 생성을 하시겠습니까?
                    </div>
                    <div className="description">
                        복사본의 주문번호1에 적용되는 난수 <b>"COPY{randomString}"</b>
                    </div>
                </StyledBody>
                <StyledFooter>
                    <CustomBlockButton
                        type='button'
                        onClick={handleCopyCreate}
                    >
                        복사 생성
                    </CustomBlockButton>
                </StyledFooter>
            </CustomDialog>
        </>
    );
}

// 5자리 임의 문자열 생성
function generateRandomString() {
    return Math.random().toString(36).substring(2, 7);
}